import {
  ICommodity,
  ICompany,
  IAirlineRate,
  RateCategoryEnum,
  RateDensityEnum,
  RateStatusEnum,
  AircraftTypeEnum,
  ULDTypeEnum,
} from '@cai-services';
import { AirlineBrand } from './airline.model';
import { AirportLight } from './airport-light.model';
import { Rate } from './rate.model';
import { UldRate } from './uld-rate.model';

export class ContractRate implements IAirlineRate {
  id: number;
  startDate: Date;
  endDate: Date;
  lastUpdatedDate: Date;
  expiryDate: Date;
  fuelSurcharge: number;
  securitySurcharge: number;
  miscellaneousCharge: number;
  saf: number;
  shcs?: string;
  airlineProdCode?: string;
  airlineRateRemarks?: string;
  airlineRateRef?: string;
  rfsRemarks?: string;
  rateStatus: RateStatusEnum;
  commodity: ICommodity;
  company: ICompany;
  originAirport: AirportLight;
  destinationAirport: AirportLight;
  airlineBrand: AirlineBrand;
  rates: Rate[];
  uldRate: UldRate;
  currency: string;
  rateCategory: RateCategoryEnum;
  aircraftTypes: AircraftTypeEnum[];
  uldType: ULDTypeEnum;
  day: string;
  flightNo: string;
  density: RateDensityEnum;
  iatacass: string;
  type: string;

  constructor(
    startDate?: Date,
    endDate?: Date,
    lastUpdatedDate?: Date,
    type?: string,
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.lastUpdatedDate = lastUpdatedDate;
    this.type = type || 'Contract';
  }
}
